import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline,MDBCardTitle, MDBCardText, MDBTypography ,MDBDataTable  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'

export default class Modaladdexperpresent extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                name_present : '', //ผู้นำเสนอ
              
                exper:[],
                articletypegroup:[],
                Articlepass:[],
                Articlepassselect:[],
                id_room:'',
                roompresent_date:'',
                roompresent_details:'',
                id_send	:'',

                id_expert:'',
                expermapforroom:[],
                
                }

            
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
            
                this.onClickradio = this.onClickradio.bind(this);
                this.gettype = this.gettype.bind(this);
                this.gettypegroup = this.gettypegroup.bind(this);
               
                this.onChangedatesapa = this.onChangedatesapa.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.getArticleconnpayforadminpass = this.getArticleconnpayforadminpass.bind(this);
                this.handleChangeaetical = this.handleChangeaetical.bind(this);
                this.getroommapexpert = this.getroommapexpert.bind(this);
    }

        onChangedatesapa(value) {
            this.setState({ roompresent_date: value.target.value });
        }


                toggle = () => {
                this.setState({
                    modal: !this.state.modal
                });
                // this.props.selectatf();
                this.gettype();
                this.getroommapexpert();
                // this.gettypegroup();
                // this.getArticleconnpayforadminpass();

                    if (localStorage.getItem('register_typemamber') === '1' || localStorage.getItem('register_typemamber') === '2') {
                    this.setState({ send_status: '2'})
                    }

                }


                onClickradio = (nr) => () => {
                this.setState({
                    radio: nr,
                });

                };




            componentDidMount() {
            const id_roompresent = this.props.id_roompresent
                //   console.log(id_send);
               // this.setState({ iduser:this.props.iduser})
                //   setTimeout(() => {
                //     //ภายใน
                //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
                //     .then(res => {
                //       console.log(res);
                //     //  this.setState({ bankname: res.data, loading: false })
                //       this.setState({ Expert: res.data})
                //     }) 
                //   }, 0);
            }



            gettype() {
                setTimeout(() => {
                api.get('registercon/selectexpertforadmin')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ exper: res.data})
                }) 
                }, 0);
            }

            gettypegroup() {
                setTimeout(() => {
                api.get('registercon/selecttpresentationtype')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ articletypegroup: res.data})
                }) 
                }, 0);
            }

            getArticleconnpayforadminpass() {
                setTimeout(() => {
                api.get('registercon/selectArticleconnpayforadminpass')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ Articlepass: res.data})
                }) 
                }, 0);
            }


            handleChangetype(event) {  
                 // this.setState({id_room: event.target.value}); 
                //   const result =  this.state.exper.filter((word) => word.id_expert === event.target.value);
                //   this.setState({Articlepassselect:result}); 
                this.setState({id_expert: event.target.value});
                 }
            handleChangeaetical(event) {   this.setState({id_send: event.target.value});  }

            handleChangenamepresent(event) {   this.setState({roompresent_details: event.target.value});  }

            getroommapexpert() {
                setTimeout(() => {
                api.get('registercon/selectexpermapforroom/'+this.props.id_roompresent)
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ expermapforroom: res.data})
                }) 
                }, 0);
              }


 handleSubmit= (e) => {
  e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_roompresent", this.props.id_roompresent);
      datafrm.append("id_expert", this.state.id_expert);
      datafrm.append("roompexpert_status", '1');
     

    api.post("registercon/Insertroommapexpert",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
            console.warn(res);
            console.log("response: ", res)
                    if (res.data = '200') {

                        Swal.fire({
                            title: 'ลงทะเบียนสำเร็จ',
                            text: "Successfully registered",
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'ตกลง'
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // window.location.href = '/Superadminroompresent'
                              // Swal.fire(
                              //   'Deleted!',
                              //   'Your file has been deleted.',
                              //   'success'
                              // )
                             // this.props.list();
                              //this.toggle()
                              this.getroommapexpert();
                            }
                          })
                    
                    }else{
                    message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.id_room)
          console.log(this.state.roompresent_date)
          console.log(this.state.roompresent_details)
        

          const items = this.state.exper.map((exper, i) => (
            <option  value={exper.id_expert	} >{exper.name_expert} </option>
          ));

          const itemsgroup = this.state.articletypegroup.map((articletypegroup, i) => (
            <option  value={articletypegroup.presentype_id} >{articletypegroup.presentype_name	}</option>
          ));

          const itemsartical = this.state.Articlepassselect.map((Articlepassselect, i) => (
            <option  value={Articlepassselect.id_send} >{Articlepassselect.name_article	}</option>
          ));

          const datast = {
            columns: [
              {
                label: 'ลำดับ',
                field: 'list',
                sort: 'list',
                width: 150
              },
              {
                label: 'ชื่อผู้ทรงคุณวุฒิ',
                field: 'name_expert',
                sort: 'name_expert',
                width: 150
              },
              {
                label: 'ความเชียวชาญ',
                field: 'expertise_expert',
                sort: 'expertise_expert	',
                width: 150
              },
              {
                label: 'เบอร์โทร',
                field: 'tel_expert',
                sort: 'tel_expert',
                width: 150
              },
              {
                label: 'จัดการ',
                field: 'group',
                sort: 'group',
                width: 150
              },
            //   {
            //     label: 'พิมพ์ชื่อบทความ',
            //     field: 'print',
            //     sort: 'print',
            //     width: 150
            //   },
            ],
      
      
            rows: [...this.state.expermapforroom.map((data, i) => (
              {
                 list: <>{i+1}</>,
                 name_expert: <>{data.name_expert} <br/> Username : {data.username_expert} <br/> Password : {data.password_expert}</>,
                 affiliation_expert	: <>{data.affiliation_expert}</>,
                 expertise_expert: <>{data.expertise_expert}</>,
                 tel_expert	: <>{data.tel_expert}</>,
                 group:<></>,
                //  print: <></>,
                //  name_admin2: <><Modaleditexpert id_expert={data.id_expert} list={this.list} /></>,
                
              }
             ))]
        
            };
                const persons = <MDBDataTable
              // searching ={true}
                searchLabel="ค้นหา ชื่อเรื่อง"
                striped
                bordered
                small 
                entries={50}
                // entriesOptions={["10", "20"]}
                order={["age", "desc"]}
                data={datast}
                entriesLabel="จำนวนที่แสดง "
                infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                responsive 
                sortRows={['random']}
                theadColor="grey lighten-1"
                />


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="mdb-color" onClick={this.toggle} size='sm'><MDBIcon icon="plus-square" />  เพิ่มผู้ทรงคุณวุฒิประจำห้อง</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              {/* <MDBModalHeader toggle={this.toggle}>เพิ่มผู้ทรงคุณวุฒิประจำห้อง {this.props.name_room} นำเสนอวันที่ {this.props.roompresent_date}</MDBModalHeader> */}
             <form 
                onSubmit={this.handleSubmit}
                 >
   
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div>
                    <br/>
           
                            {/* <div className="mb-2">
                            <label><strong>สาขาการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangemajor}>
                                        <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                         <option value="สาขาวิทยาศาสตร์และเทคโนโลยี" >สาขาวิทยาศาสตร์และเทคโนโลยี</option>
                                         <option value="สาขามนุษยศาสตร์และสังคมศาสตร์" >สาขามนุษยศาสตร์และสังคมศาสตร์</option>
                            </select>
                            </div> */}
                         {/* <h5>เพิ่มผู้ทรงคุณวุฒิประจำห้อง</h5> */}
                         <MDBCardTitle>  <MDBTypography note noteColor='primary' noteTitle={'เพิ่มผู้ทรงคุณวุฒิประจำห้อง '+`${this.props.name_room}` +' วันที่ '+`${this.props.roompresent_date}`} > </MDBTypography></MDBCardTitle>

                            <div className="mb-2">
                            <label><strong>ผู้ทรงคุณวุฒิ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype} required>
                              <option value="" >---เลือกผู้ทรงคุณวุฒิ---</option>
                              {items}
                                     
                            </select>
                            </div>
                            <div className='text-center'><MDBBtn color="primary" type='submit' ><MDBIcon icon="print" /> บันทึก</MDBBtn></div>
                            {persons}

                         
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
                 {/* <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn> */}
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
              </form>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
